var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSegmentinline = function SvgSegmentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#segment_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "segment_inline_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#52BD95",
    mask: "url(#segment_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5.164h8.681c.184 0 .332.148.332.332v.957a.33.33 0 0 1-.332.332H6.2a.33.33 0 0 1-.333-.332v-.957c0-.184.148-.332.333-.332M.416 9.219h8.682c.184 0 .332.148.332.332v.956a.33.33 0 0 1-.332.332H.416a.33.33 0 0 1-.332-.332v-.956c0-.184.148-.332.332-.332M1.203 6.273a.304.304 0 0 0 .368-.21 6.38 6.38 0 0 1 7.455-4.289.3.3 0 0 0 .352-.22l.266-.987A.3.3 0 0 0 9.61.332a.32.32 0 0 0-.195-.138 8.015 8.015 0 0 0-9.402 5.44.3.3 0 0 0 .025.23c.041.067.108.123.184.144zM14.092 9.725a.31.31 0 0 0-.373.21 6.38 6.38 0 0 1-7.455 4.294.3.3 0 0 0-.353.22l-.26.982a.3.3 0 0 0 .035.235c.041.071.113.122.195.138a8.004 8.004 0 0 0 9.397-5.435.3.3 0 0 0-.21-.373zM12.267 3.385a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78M3.028 14.397a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "segment_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSegmentinline;